import React, { useMemo, useState } from 'react';
import Box from '@material-ui/core/Box';
import { createMuiTheme, CssBaseline, IconButton, makeStyles, ThemeProvider, Tooltip } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import HbxTabs from '../../../atoms/tabs/HbxTabs';
import { useBottomDrawer } from '../../../../hooks/useBottomDrawer';
import { themeConfig } from '../../../../theme';
import { MdiDockBottom, MdiDockRight } from '../../../atoms/Icons';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import HelpIcon from '@material-ui/icons/Help';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveLabel, triggerTour, setIsDocumentClicked, setForcedFocus } from '../../../../store/global/actions';
import { useEffect } from 'react';
import { getActiveLabel, getForcedFocus, getTabOnFocus } from '../../../../store/global/selectors';
import { getCodeEditStatus } from '../../../../store/global/selectors';

const MIN_DRAWER_WIDTH_FOR_PANE = 850;

const smallInputTheme = createMuiTheme({
  ...themeConfig,
  // props: {
  //   MuiTextField: {
  //     size: 'small',
  //     margin: 'dense',
  //   },
  //   MuiSelect: {
  //     margin: 'dense',
  //   },
  //   MuiFormControl: {
  //     margin: 'dense',
  //   },
  //   MuiButton: {
  //     size: 'small',
  //   },
  // },
  // overrides: {
  //   ...themeConfig.overrides,
  //   MuiOutlinedInput: {
  //     input: {
  //       padding: "8px 10px", // reduce default padding
  //       fontSize: "0.875rem", // reduce font size
  //     },
  //     root: {
  //       '& $notchedOutline': {
  //         top: 0, // fix label alignment if needed
  //       }
  //     }
  //   },
  //   MuiFormHelperText: {
  //     contained: {
  //       marginTop: 4, // reduce helperText top margin
  //     }
  //   },
  //   MuiInputLabel: {
  //     outlined: {
  //       transform: "translate(14px, 12px) scale(1)", // tighter label position
  //     },
  //     shrink: {
  //       transform: "translate(14px, -6px) scale(0.75)", // when floating
  //     }
  //   }
  // }
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  drawerOpen: {
    width: '20%',
    minWidth: '20%',
    position: 'relative',
    maxWidth: 500,
    transition: 'width 0.3s ease',
    borderRight: '1px solid #ccc',
    overflowY: 'auto'
  },
  drawerCollapsed: {
    width: 0,
    position: 'relative',
    transition: 'width 0.2s ease',
    overflow: 'hidden',
  },
  rightPanel: {
    height: '100%',
    width: '70%',
    flexGrow: 1,
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column'
  },
  rightPanelContent: {
    padding: '0 30px 20px',
    width: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  },
  toggleButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: 0,
  },
  toggleButton: {
    backgroundColor: '#ffeb3b', // yellow background
    borderRadius: '50%',
    width: 20,
    height: 20,
    boxShadow: '0 0 5px rgba(0,0,0,0.2)',
    padding: 0,
    zIndex: 1000,
    outline: 'none',
    position: 'absolute',
    left: "-2px", 
    '&:hover': {
      backgroundColor: '#fff176',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  iconButton: ({leftPaneStatus}) => ({
    width: 22,
    height: 22,
    margin: '4px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: '#000000',
    '& svg': {
        fontSize: '20px',
    },
    '&:hover': {
        backgroundColor: '#00000017',
    },
    '&:focus': {
        outline: 'none',
        boxShadow: 'none',
    },
  }),
  arrowIcon: ({leftPaneStatus, dockPosition, width}) => ({
    width: 20,
    height: 20,
    border: '1.5px solid #000',
    position: "absolute",
    top: "50%",
    left: leftPaneStatus? '20%' : 0,
    zIndex: 10000,
    padding: 0,
    background: "#fff",
    transform: dockPosition === "right" ? 'translate(-30%, -86%)' :'translate(-30%, -50%)',
    borderRadius: '50%',
    '& svg': {
        fontSize: '16px',
        color: 'black'
    },
    '&:hover': {
        backgroundColor: '#3c4756',
        '& svg': {
          color: 'white'
        }
    },
    '&:focus': {
        outline: 'none',
        boxShadow: 'none',
    },
  })
}));

const BottomDrawerContent = ({leftPane, children, onTabChange, currentWidth, drawerWidth, showTour}) => {
  const {activeTab, setActiveTab, tabConfig, dockPosition, setDockPosition, leftPaneStatus, setLeftPaneStatus} = useBottomDrawer()
  const [isLeftPaneOpen, setLeftPaneOpen] = useState(leftPaneStatus)
  const dispatch = useDispatch();
  const classes = useStyles({ drawerOpen: isLeftPaneOpen, leftPaneStatus, dockPosition }); // pass dynamic prop
  const activeLabel = useSelector(getActiveLabel);
  const isForcedTabOnFocus = useSelector(getForcedFocus);
  const tabOnFocus = useSelector(getTabOnFocus);

  const codeEditStatus = useSelector(getCodeEditStatus);
  

  const handleTabChange = (_, tab) => {
    if (codeEditStatus) {
      dispatch(setIsDocumentClicked());
      return;
    }
    if (isForcedTabOnFocus) {
      dispatch(setForcedFocus(false));
    }

    setActiveTab(tab);
    if(onTabChange){
      onTabChange(tab)
    }
  }

  const handleManualTour = () => {
    switch(showTour){
        case 'view':
            dispatch(triggerTour({currentTour: 'viewTab', initStart: true}))
            break;
        case "section":
            dispatch(triggerTour({currentTour: 'sectionTab', initStart: true}))
            break;
        case "ui":
            dispatch(triggerTour({currentTour: 'widgetTab', initStart: true}))
            break;
        case "transactionTabs":
            dispatch(triggerTour({currentTour: 'transactionTabs', initStart: true}))
            break;
        case "eventTabs":
            dispatch(triggerTour({currentTour: 'eventTabs', initStart: true}))
            break;
        case "delegateTabs":
                dispatch(triggerTour({currentTour: 'delegateTabs', initStart: true}))
                break;
        case "digitalTwinTabs":
            dispatch(triggerTour({currentTour: 'digitalTwinTabs', initStart: true}))
            break;
        case "clusterletTabs":
            dispatch(triggerTour({currentTour: 'clusterletTabs', initStart: true}))
            break;
        case "eventTypesTabs":
            dispatch(triggerTour({currentTour: 'eventTypesTabs', initStart: true}))
            break;
        default: 
            break;
    }
          
  }
  
  useMemo(() => {
    setLeftPaneOpen(leftPaneStatus)
  },[leftPaneStatus])

  useMemo(() => {
    if(dockPosition === 'bottom'){
      setLeftPaneOpen(leftPaneStatus)
    }else if(dockPosition === 'right' && currentWidth < MIN_DRAWER_WIDTH_FOR_PANE){
      setLeftPaneOpen(false)
    }
  },[dockPosition])

  useMemo(() => {
    if(currentWidth < MIN_DRAWER_WIDTH_FOR_PANE){
      setLeftPaneOpen(false)
    }else{
      setLeftPaneOpen(leftPaneStatus)
    }
  },[currentWidth])

  useMemo(() => {
    if(activeTab !== null && tabConfig?.length > 0){
      setTimeout(() => {
        dispatch(setActiveLabel(tabConfig[activeTab]?.label))
      },500)
    }
  },[activeTab, tabConfig])

  useEffect(() => {
    if(!isForcedTabOnFocus && activeLabel && tabConfig){
      const active = tabConfig.findIndex(item => item.label === activeLabel);
      if(active !== -1){
        setActiveTab(active)
      }else{
        setActiveTab(0)
      }
    } else if (isForcedTabOnFocus && tabOnFocus !== null) {
      setActiveTab(tabOnFocus)
    }
  },[tabConfig])
  return (

      <Box className={classes.root}>

        {
          leftPane && (currentWidth > MIN_DRAWER_WIDTH_FOR_PANE || dockPosition === 'bottom') &&
          <Tooltip title={leftPaneStatus ? 'Close Left Pane' : 'Open Left Pane'}>
            <IconButton
              className={classes.arrowIcon} 
              onClick={() => setLeftPaneStatus(!leftPaneStatus)}
              id={`${leftPaneStatus ? "collpase" : "expand"}_side_panel_btn`}
            > 
              {
                leftPaneStatus ? 
                <ChevronLeft />
                :
                <ChevronRight />
              }
            </IconButton>
          </Tooltip>
        }

        {/* Left Panel */}
        <Box id="drawer-content-left-panel" className={`${leftPane && isLeftPaneOpen ? classes.drawerOpen : classes.drawerCollapsed} `} style={{width: `${leftPane && isLeftPaneOpen ? "20%" : "0%"}`, transition: 'width 0.3s ease'}} >
            {leftPane}
        </Box> 

        {/* Right Panel */}
        <Box id="drawer-content-right-panel" className={`${classes.rightPanel} drawer-content-panel `} style={{width: `${isLeftPaneOpen ? "80%" : "100%"}`, transition: 'width 0.3s ease'}} >
          {/* {
            dockPosition === 'right' && currentWidth > MIN_DRAWER_WIDTH_FOR_PANE && leftPane &&
            <Tooltip title={leftPaneStatus ? 'Close Left Pane' : 'Open Left Pane'}>
              <IconButton
                className={classes.arrowIcon} 
                onClick={() => setLeftPaneStatus(!leftPaneStatus)}
              > 
                {
                  leftPaneStatus ? 
                  <ChevronLeft />
                  :
                  <ChevronRight />
                }
              </IconButton>
            </Tooltip>
          } */}
          <div 
            style={{
              display: 'grid', 
              gridTemplateColumns: "auto 3rem", 
              position: 'sticky', 
              top: 0, 
              background: '#fff',
              zIndex: 10
            }}> 
            {
              tabConfig &&
              <HbxTabs 
                tabs={tabConfig}
                activeTab={activeTab}
                onChange={handleTabChange}
              />
            }
            
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginRight: '10px'}}>
                {
                  showTour &&
                  <Tooltip title='Show Tour'>
                      <IconButton size='small' data-ui-tour-id="ui-tour" className={classes.iconButton} onClick={handleManualTour}>
                        <HelpIcon/>
                      </IconButton>
                  </Tooltip>
                }
                {
                  dockPosition !== 'right' &&
                  <Tooltip title="Dock to right">
                    <IconButton 
                      size='small' 
                      data-ui-tour-id="dock-btn" 
                      id="dock_right_btn" 
                      className={classes.iconButton} 
                      onClick={() => setDockPosition('right')}
                    >
                      <MdiDockRight />
                    </IconButton>
                  </Tooltip>
                }
                {
                  dockPosition !== 'bottom' &&
                  <Tooltip title="Dock to bottom">
                    <IconButton 
                      size='small' 
                      data-ui-tour-id="dock-btn" 
                      id="dock_bottom_btn" 
                      className={classes.iconButton} 
                      onClick={() => setDockPosition('bottom')}
                    >
                      <MdiDockBottom  />
                    </IconButton>
                  </Tooltip>
                }
            </div>
          </div>
          <ThemeProvider theme={smallInputTheme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </Box>

      </Box>
  );
};

export default BottomDrawerContent;
